import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";

export interface ReviewSectionProps {
  title: string;
  children: React.ReactNode;
  "data-cy"?: string;
}

export const ReviewSection: FC<ReviewSectionProps> = ({ title, children, "data-cy": dataCy }) => (
  <div className="review-section" data-cy={dataCy}>
    <Text fontSize="T300" fontWeight="bold" className="review-section-title">
      {title}
    </Text>
    <div className="review-section-divider" />
    <div>{children}</div>
  </div>
);
